import i18n from '@/plugins/i18n';
import { pickLocalized } from '@/utils/i18nName';

/**
 * ชื่อร้าน — ค่าประจำร้านที่อ่านตอน "รัน" ไม่ใช่ฝังตอน build
 *
 * ตอน build ค่าพวกนี้ถูก compile เป็น `(window.__APP_CONFIG__||{}).BRAND_NAME`
 * (ดู RUNTIME_KEYS ใน vue.config.js) แล้ว container ของ web เขียน config.js ให้ตอน start
 * จาก WEB_BRAND_NAME / WEB_BRAND_NAME_EN ใน shops/<slug>/.env
 * → siva-web เป็น image เดียวใช้ได้ทุกร้าน เปิดร้านใหม่ไม่ต้อง build
 *
 * รูปคู่ name / name_en ตั้งใจให้ตรงกับคอนเวนชันชื่อ 2 ภาษาที่ API ส่งมา (docs/bilingual-menu.md)
 * จะได้ส่งเข้า `$ln()` ตัวเดียวกับชื่อสินค้า/หมวดได้เลย ไม่ต้องมีทางแยกของตัวเอง
 *
 * ⚠️ ห้ามอ่าน process.env.VUE_APP_BRAND_NAME ตรง ๆ ที่อื่นอีก — ให้ผ่านที่นี่ที่เดียว
 *    ไม่งั้นจุดที่ลืมจะค้างเป็นภาษาไทยตอนสลับเป็นอังกฤษแบบเงียบ ๆ
 */
export const brand = {
  name: process.env.VUE_APP_BRAND_NAME || '',
  name_en: process.env.VUE_APP_BRAND_NAME_EN || '',
};

/**
 * ชื่อร้านตามภาษาที่เลือกอยู่ — สำหรับโค้ด "นอก component" (ยูทิลสร้างเอกสารพิมพ์)
 * ที่ไม่มี `this.$ln` ให้เรียก · ใน component ใช้ `$ln($brand)` ตามปกติ
 */
export function brandName() {
  return pickLocalized(brand, i18n.global.locale, 'name');
}
